<template>
  <div class="items-per-page">
    <span>
      {{ getProductOverviewTranslations['ProductsOverview.ItemsPerPage'] }}
    </span>
    <select
      id="paginationSettings"
      v-model="top"
      name="paginationSettings"
      class="custom-select items-per-page__select"
    >
      <option
        v-for="option of paginationSettings.topOptions"
        :key="option"
        :value="option"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ItemsPerPage',
  computed: {
    ...mapGetters('productSearch', ['buildQuery']),
    ...mapState('productSearch', ['paginationSettings', 'query']),
    ...mapGetters('translations', ['getProductOverviewTranslations']),
    top: {
      get() {
        return this.query.top;
      },
      set(value) {
        this.$router.push(this.buildQuery({ page: 1, top: value }));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '~bootstrap/scss/mixins';

.items-per-page {
  display: flex;
  gap: 20px;
  align-items: center;

  @include media-breakpoint-down(sm) {
    display: none;
  }

  &__select {
    padding: 10px 20px 10px 10px;
    background-color: $white;
    color: $body-color;
    border-color: $light;
    width: auto;
    min-width: 75px;
    height: auto;
    min-height: 45px;
  }
}
</style>
